/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FlightBagOption
 */
export interface FlightBagOption {
  /**
   * Exact numbered bag piece. Requires quantity one and a known included_pieces count; omitted for fungible quantity services.
   * @type {number}
   * @memberof FlightBagOption
   */
  pieceOrdinal?: number;
  /**
   * Authoritative included piece count for every passenger and segment in this service scope. Unknown counts must be omitted, never inferred as zero.
   * @type {number}
   * @memberof FlightBagOption
   */
  includedPieces?: number;
  /**
   *
   * @type {string}
   * @memberof FlightBagOption
   */
  selectionToken: string;
  /**
   *
   * @type {Array<number>}
   * @memberof FlightBagOption
   */
  passengerIndices: Array<number>;
  /**
   *
   * @type {Array<number>}
   * @memberof FlightBagOption
   */
  segmentIndices: Array<number>;
  /**
   *
   * @type {string}
   * @memberof FlightBagOption
   */
  baggageType: FlightBagOptionBaggageTypeEnum;
  /**
   *
   * @type {string}
   * @memberof FlightBagOption
   */
  unitAmount: string;
  /**
   *
   * @type {string}
   * @memberof FlightBagOption
   */
  currency: string;
  /**
   *
   * @type {number}
   * @memberof FlightBagOption
   */
  maximumQuantity: number;
  /**
   *
   * @type {string}
   * @memberof FlightBagOption
   */
  maximumWeightKg?: string | null;
  /**
   *
   * @type {string}
   * @memberof FlightBagOption
   */
  maximumLengthCm?: string | null;
  /**
   *
   * @type {string}
   * @memberof FlightBagOption
   */
  maximumHeightCm?: string | null;
  /**
   *
   * @type {string}
   * @memberof FlightBagOption
   */
  maximumDepthCm?: string | null;
  /**
   *
   * @type {Date}
   * @memberof FlightBagOption
   */
  expiresAt: Date;
}

/**
 * @export
 */
export const FlightBagOptionBaggageTypeEnum = {
  Checked: "checked",
  CarryOn: "carry_on",
} as const;
export type FlightBagOptionBaggageTypeEnum =
  (typeof FlightBagOptionBaggageTypeEnum)[keyof typeof FlightBagOptionBaggageTypeEnum];

/**
 * Check if a given object implements the FlightBagOption interface.
 */
export function instanceOfFlightBagOption(
  value: object
): value is FlightBagOption {
  if (!("selectionToken" in value) || value["selectionToken"] === undefined)
    return false;
  if (!("passengerIndices" in value) || value["passengerIndices"] === undefined)
    return false;
  if (!("segmentIndices" in value) || value["segmentIndices"] === undefined)
    return false;
  if (!("baggageType" in value) || value["baggageType"] === undefined)
    return false;
  if (!("unitAmount" in value) || value["unitAmount"] === undefined)
    return false;
  if (!("currency" in value) || value["currency"] === undefined) return false;
  if (!("maximumQuantity" in value) || value["maximumQuantity"] === undefined)
    return false;
  if (!("expiresAt" in value) || value["expiresAt"] === undefined) return false;
  return true;
}

export function FlightBagOptionFromJSON(json: any): FlightBagOption {
  return FlightBagOptionFromJSONTyped(json, false);
}

export function FlightBagOptionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightBagOption {
  if (json == null) {
    return json;
  }
  return {
    pieceOrdinal:
      json["piece_ordinal"] == null ? undefined : json["piece_ordinal"],
    includedPieces:
      json["included_pieces"] == null ? undefined : json["included_pieces"],
    selectionToken: json["selection_token"],
    passengerIndices: json["passenger_indices"],
    segmentIndices: json["segment_indices"],
    baggageType: json["baggage_type"],
    unitAmount: json["unit_amount"],
    currency: json["currency"],
    maximumQuantity: json["maximum_quantity"],
    maximumWeightKg:
      json["maximum_weight_kg"] == null ? undefined : json["maximum_weight_kg"],
    maximumLengthCm:
      json["maximum_length_cm"] == null ? undefined : json["maximum_length_cm"],
    maximumHeightCm:
      json["maximum_height_cm"] == null ? undefined : json["maximum_height_cm"],
    maximumDepthCm:
      json["maximum_depth_cm"] == null ? undefined : json["maximum_depth_cm"],
    expiresAt: new Date(json["expires_at"]),
  };
}

export function FlightBagOptionToJSON(json: any): FlightBagOption {
  return FlightBagOptionToJSONTyped(json, false);
}

export function FlightBagOptionToJSONTyped(
  value?: FlightBagOption | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    piece_ordinal: value["pieceOrdinal"],
    included_pieces: value["includedPieces"],
    selection_token: value["selectionToken"],
    passenger_indices: value["passengerIndices"],
    segment_indices: value["segmentIndices"],
    baggage_type: value["baggageType"],
    unit_amount: value["unitAmount"],
    currency: value["currency"],
    maximum_quantity: value["maximumQuantity"],
    maximum_weight_kg: value["maximumWeightKg"],
    maximum_length_cm: value["maximumLengthCm"],
    maximum_height_cm: value["maximumHeightCm"],
    maximum_depth_cm: value["maximumDepthCm"],
    expires_at: value["expiresAt"].toISOString(),
  };
}
